/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Answer_1Inputs */

const en_help_center__payments_n_refunds__answer_1 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Answer_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No! The prices you see are the prices you pay. Entry prices and bid packages include BTW (21%). With Free Accounts the only additional cost is shipping if you win (varies by product size/location).
For Premium accounts there are no additional costs for shipping.`)
};

/**
* | output |
* | --- |
* | "No! The prices you see are the prices you pay. Entry prices and bid packages include BTW (21%). With Free Accounts the only additional cost is shipping if yo..." |
*
* @param {Help_Center__Payments_N_Refunds__Answer_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__answer_1 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Answer_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__answer_1(inputs)
});